import React, { useEffect } from 'react';
import {
  Input,
  Table,
  Button,
  message,
  Modal,
  Carousel,
  Col,
  Row,
  Select,
  Dropdown,
  Menu,
} from 'antd';
import Navbar from 'src/common/Navbar/Navbar';
import {
  DeliveryRequestProps,
  DeliveryRequestState,
  DeliveryConsignmentTripColumnList,
  DeliveryConsignmentISTColumnList,
  isPODPresentForConsignments,
} from './DeliveryAcknowledgement.utils';
import { HocOptions } from 'src/common/generic-hoc.types';
import GenericHoc from 'src/common/generic-hoc';
import { DeliveryRequestStyles } from './DeliveryAcknowledgement.styles';
import { useGenericState } from 'src/library/UseGenericState';
import {
  getInvoiceConsignmentList, updateInvoicePodList, uploadFilesAndSavePOD,
  fetchInvoiceNumbers, setSelectedRowKeys, markCNsAsDelivered, markCNsAsUndelivered,
  filterCnData, markCNsAsPickedUp, markCNsAsNotPickedUp,
  fetchISTInvoiceNumbers,
  markCNsAsUndeliveredIST,
  markCNsAsDeliveredIST,
  setPieceLevelActions,
  setEventTimestamp,
} from './DeliveryAcknowledgement.actionsCreator';
import { setTicketingToolVisibility, setTicketingToolURL } from '../../Ticket-managment/TicketManagement.actions';
import { CloudUploadOutlined, DeleteOutlined, LeftCircleOutlined, RightCircleOutlined, SearchOutlined, DownOutlined, WarningFilled } from '@ant-design/icons';
import SearchSelectTagsInput from 'src/common/SearchSelectTagsInput';
import PodUpload from 'src/common/PodUpload';
import PdfRenderer from 'src/common/PdfRenderer';
import { getConsignmentStatusPrettyName } from '../../../utils/consignmentUtils';
import * as lodash from 'lodash';
import EllipsisIcon from 'src/assets/icons/ellipsisIcon';
import EditPieceDetailsSideDrawer from './EditPieceDetailsSideDrawer';
import RenderImage from 'src/common/RenderImage';
import { getRequiredInvoiceConfig } from '../Invoices/Invoices.utils';
import NdrNprReasonModal from './NdrNprReasonModal';
import DeliveryPickupModal from './DeliveryPickupModal';

const DeliveryAcknowledgement = (props: DeliveryRequestProps) => {
  const {
    classes,
    deliveryAcknowledgement,
    getInvoiceConsignments,
    updateInvoicePODList,
    uploadFilesAndSave,
    fetchInvoiceNumbers,
    fetchISTInvoiceNumbers,
    setSelectedRowKeys,
    markCNsAsDelivered,
    markCNsAsDeliveredIST,
    markCNsAsUndelivered,
    markCNsAsUndeliveredIST,
    markCNsAsPickedUp,
    markCNsAsNotPickedUp,
    filterCnData,
    consignmentActionConfig,
    t,
    showVehicleRequestsMM,
    setTicketingToolVisibility,
    setTicketingToolURL,
    ticketingToolURL,
    orgData,
  } = props;

  const [state, setState] = useGenericState<DeliveryRequestState>({
    searchFilterQuery: '',
    isUploadPODModalVisible: false,
    isImageModalVisible: false,
    galleryImageData: [],
    uploadPODFiles: [],
    pdfUrl: null,
    isPdfViewVisible: false,
    searchType: 'reference_number',
    tripType: 'trip',
    isEditPieceDetailsModalVisible: false,
    selectedRowData: {},
    pieceActionList: {},
    actionType: null,
    isReasonModalVisible: false,
    reasonModalAction: 'delivery',
  });

  const [isDeliveryPickupModalVisible, setIsDeliveryPickupModalVisible] = React.useState(false);
  const [deliveryPickupAction, setDeliveryPickupAction] = React.useState<'delivery' | 'pickup'>('delivery');

  const {
    isUploadPODModalVisible,
    isImageModalVisible,
    galleryImageData,
    isPdfViewVisible,
    pdfUrl,
    searchType,
    tripType,
    isEditPieceDetailsModalVisible,
    selectedRowData,
    pieceActionList,
    actionType,
    isReasonModalVisible,
    reasonModalAction,
  } = state;

  const searchTypes = [
    {
      value: 'reference_number',
      label: t('Reference Number'),
    },
    {
      value: 'courier_partner_reference_number',
      label: t('Carrier Reference Number'),
    },
    {
      value: 'invoice_number',
      label: t('Invoice Number'),
    },
    {
      value: 'customer_name',
      label: t('Customer Name'),
    },
    {
      value: 'customer_category',
      label: t('Customer Category'),
    },
    {
      value: 'customer_code',
      label: t('Customer Code'),
    },
    {
      value: 'trip_reference_number',
      label: t('Trip Reference Number'),
    },
  ];

  const istSearchTypes = [
    {
      value: 'reference_number',
      label: t('Reference Number'),
    },
    {
      value: 'courier_partner_reference_number',
      label: t('Carrier Reference Number'),
    },
    {
      value: 'invoice_number',
      label: t('Invoice Number'),
    },
    {
      value: 'customer_name',
      label: t('Customer Name'),
    },
    {
      value: 'customer_category',
      label: t('Customer Category'),
    },
    {
      value: 'customer_code',
      label: t('Customer Code'),
    },
    {
      value: 'ist_reference_number',
      label: t('Trip Reference Number'),
    },
  ];

  const tripTypes = [
    {
      value: 'trip',
      label: t('FLM'),
    },
    {
      value: 'ist',
      label: t('MM'),
    },
  ];

  const requiredDataForConfig = {
    vendorData: {
      vendor_category: deliveryAcknowledgement?.filteredConsignments?.[0]?.vendor_category,
    },
  };

  const requiredConfig = getRequiredInvoiceConfig(
    consignmentActionConfig?.flow_config,
    requiredDataForConfig,
  );

  const showPieceLevelActions = requiredConfig?.show_piece_level_actions || false;
  const showBulkUpload = requiredConfig?.bulk_upload_actions?.length || false;

  const handleSearchTypeChange = (value) => {
    setState({ searchType: value });
  };

  const handleTripTypeChange = (value) => {
    setState({ tripType: value, searchType: 'reference_number' });
  };

  const renderGallery = (data) => {
    if ((Array.isArray(data) && !data.length) || (!Array.isArray(data) && !data)) {
      return t('Not Available');
    }
    return (
      <>
        <div
          onClick={() => {
            setState({ galleryImageData: data, isImageModalVisible: true });
          }}
          className={classes.btn}
        >
          {t('View')}
        </div>
      </>
    );
  };

  const handleEditPiecesDetails = (record, isDisabled) => {
    if (isDisabled) return;
    setState({ selectedRowData: record, isEditPieceDetailsModalVisible: true });
  };

  // Function to check if an action is hidden based on the flow configuration
  const isActionHidden = (actionKey: string) => {
    const { selectedRowKeys } = deliveryAcknowledgement;
    const requiredConsignment = deliveryAcknowledgement.consignments?.find(
      (cn) => cn.reference_number === selectedRowKeys[0],
    );

    const requiredConfig = getRequiredInvoiceConfig(
      consignmentActionConfig?.flow_config,
      { consignmentData: requiredConsignment },
    );

    if (requiredConfig && requiredConfig[actionKey]) {
      return requiredConfig[actionKey].hidden === true;
    }
    return false;
  };

  const handleMarkDelivered = () => {
    const { selectedRowKeys, consignments } = deliveryAcknowledgement;
    if (!(Array.isArray(selectedRowKeys) && selectedRowKeys.length)) {
      message.error(t('Please select consignments'));
      return;
    }
    if (tripType === 'ist') {
      markCNsAsDeliveredIST();
    } else {
      setIsDeliveryPickupModalVisible(true);
      setDeliveryPickupAction('delivery');
    }
  };

  const handleMarkUndelivered = () => {
    const { selectedRowKeys, consignments } = deliveryAcknowledgement;
    if (!(Array.isArray(selectedRowKeys) && selectedRowKeys.length)) {
      message.error(t('Please select consignments'));
      return;
    }
    setState({
      isReasonModalVisible: true,
      reasonModalAction: 'delivery',
    });
  };

  const closeReasonModal = () => {
    setState({ isReasonModalVisible: false });
  };

  const handleReasonConfirm = async (payload) => {
    const { reasonName, reasonId, comment } = payload || {};
    if (reasonModalAction === 'pickup') {
      await markCNsAsNotPickedUp({
        reasonName,
        reasonId,
        comment,
      });
    } else if (tripType === 'ist') {
      markCNsAsUndeliveredIST();
    } else {
      await markCNsAsUndelivered({
        reasonName,
        reasonId,
        comment,
      });
    }
    closeReasonModal();
  };

  const handleMarkPickupCompleted = () => {
    const { selectedRowKeys } = deliveryAcknowledgement;
    if (!(Array.isArray(selectedRowKeys) && selectedRowKeys.length)) {
      message.error(t('Please select consignments'));
    } else {
      setIsDeliveryPickupModalVisible(true);
      setDeliveryPickupAction('pickup');
    }
  };

  const handleDeliveryPickupConfirm = async ({
    podUrlList = [],
    eventTime,
    actionType: confirmActionType = 'delivery',
  }: {
    podUrlList?: Array<{ url: string; type: string }>;
    eventTime?: string;
    actionType?: 'delivery' | 'pickup';
  }) => {
    const { selectedRowKeys, consignments } = deliveryAcknowledgement as any;
    const existingMap = (deliveryAcknowledgement as any)?.pieceLevelActions || {};
    const updated: Record<string, any> = { ...existingMap };

    const selectedConsignments = (consignments || [])
      .filter((cn) => selectedRowKeys?.includes(cn.reference_number));

    if (!Array.isArray(selectedConsignments) || selectedConsignments.length === 0) {
      message.error(t('Please select consignments'));
      return;
    }
    const data: any = {
      eventTime,
    };

    if (showPieceLevelActions) {
      selectedConsignments.forEach((cn: any) => {
        (cn.pieces_detail || []).forEach((piece: any) => {
          const existing = updated[piece.reference_number] || {};
          updated[piece.reference_number] = {
            ...existing,
            status: confirmActionType === 'delivery' ? 'delivered' : 'pickup_completed',
            pod: (Array.isArray(podUrlList) && podUrlList.length) ? podUrlList : existing.pod,
          };
        });
      });
      data.pieceLevelActions = updated;
    } else if (Array.isArray(podUrlList) && podUrlList.length) {
      data.proof_image_list = podUrlList;
    }

    if (confirmActionType === 'delivery') {
      await markCNsAsDelivered(data);
    } else {
      await markCNsAsPickedUp(data);
    }
    setIsDeliveryPickupModalVisible(false);
  };

  const handleMarkNotPickedUp = () => {
    const { selectedRowKeys, consignments } = deliveryAcknowledgement;
    if (!(Array.isArray(selectedRowKeys) && selectedRowKeys.length)) {
      message.error(t('Please select consignments'));
      return;
    }
    setState({
      isReasonModalVisible: true,
      reasonModalAction: 'pickup',
    });
  };

  const handleUploadPOD = () => {
    const { selectedRowKeys } = deliveryAcknowledgement;
    if (!(Array.isArray(selectedRowKeys) && selectedRowKeys.length)) {
      message.error(t('Please select consignments'));
    } else {
      setState({ isUploadPODModalVisible: true });
    }
  };

  const handleMarkDeliveredClick = () => {
    if (
      !showPieceLevelActions ||
      !selectedRowData?.pieces_detail?.length ||
      selectedRowData?.pieces_detail?.some((piece) => !piece?.reference_number)
    ) {
      handleMarkDelivered();
    } else {
      setState({ isEditPieceDetailsModalVisible: true, actionType: 'delivery' });
    }
  };

  const handleMarkPickupCompletedClick = () => {
    if (
      !showPieceLevelActions ||
      !selectedRowData?.pieces_detail?.length ||
      selectedRowData?.pieces_detail?.some((piece) => !piece?.reference_number)
    ) {
      handleMarkPickupCompleted();
    } else {
      setState({ isEditPieceDetailsModalVisible: true, actionType: 'pickup' });
    }
  };

  const handleRaiseTicket = () => {
    const { selectedRowKeys, consignments = [] } = deliveryAcknowledgement;
    const selectedConsignment = consignments.find(
      (cn) => cn.reference_number === selectedRowKeys[0],
    );

    const { custom_fields_formatted = [] } = orgData;
    const custom_fields_params = custom_fields_formatted
      .filter((custom_field) => selectedConsignment[custom_field?.field])
      .map((custom_field) => `${encodeURIComponent(custom_field?.pretty_name)}=${encodeURIComponent(selectedConsignment[custom_field?.field])}`);

    const queryString = custom_fields_params.join('&');
    const toAddInQuerString = queryString ? `&${queryString}` : '';
    const lang = window.localStorage.getItem('lng') || 'en';

    setTicketingToolURL(
      `${ticketingToolURL}&${encodeURIComponent('Consignment Number')}=${selectedConsignment?.reference_number || null}&${encodeURIComponent('Trip Number')}=${selectedConsignment?.trip_organisation_reference_number || null}${toAddInQuerString}&lng=${lang}`,
    );
    setTicketingToolVisibility(true);
  };

  const actionMenu = (record: any = {}, isBulkAction: boolean = false) => {
    const isDisabled = ['delivered', 'attempted'].includes(record.status);
    const currentVendorId = window.localStorage.getItem('userId');
    const vendorId = record.flm_vendor_id || record.ist_vendor_id;
    const canRaiseTicket = showPieceLevelActions && vendorId === currentVendorId;

    const requiredConfig = getRequiredInvoiceConfig(
      consignmentActionConfig?.flow_config,
      { consignmentData: record },
    );

    const bulkUploadActions = requiredConfig?.bulk_upload_actions || [];
    const isActionAllowedInBulk = (actionKey: string) => {
      if (!isBulkAction) return true;
      return bulkUploadActions.includes(actionKey);
    };

    return (
      <Menu>
        {
          !isActionHidden('delivered') && isActionAllowedInBulk('delivered') ?
            <Menu.Item key="1" onClick={handleMarkDeliveredClick} disabled={isDisabled}>
              {t('Mark Delivered')}
            </Menu.Item> : null
        }
        {
          !isActionHidden('undelivered') && isActionAllowedInBulk('undelivered') ?
            <Menu.Item key="2" onClick={handleMarkUndelivered} disabled={isDisabled}>
              {t('Mark Undelivered')}
            </Menu.Item> : null
        }
        {
          isActionAllowedInBulk('upload_pod') ?
            <Menu.Item
              key="3"
              onClick={handleUploadPOD}
              disabled={isDisabled || isActionHidden('upload_pod')}
            >
              {t('Upload POD')}
            </Menu.Item> : null
        }
        {
          tripType !== 'ist' && !isActionHidden('pickup_completed') && isActionAllowedInBulk('pickup_completed') ?
            <Menu.Item key="4" onClick={handleMarkPickupCompletedClick} disabled={isDisabled}>
              {t('Mark Pickup Completed')}
            </Menu.Item> : null
        }
        {
          tripType !== 'ist' && !isActionHidden('not_picked_up') && isActionAllowedInBulk('not_picked_up') ?
            <Menu.Item key="6" onClick={handleMarkNotPickedUp} disabled={isDisabled}>
              {t('Mark Not Picked Up')}
            </Menu.Item> : null
        }
        {
          canRaiseTicket && selectedRowData?.reference_number && isActionAllowedInBulk('raise_ticket') ?
            <Menu.Item key="5" onClick={handleRaiseTicket}>
              {t('Raise Ticket')}
            </Menu.Item> : null
        }
      </Menu>
    );
  };

  const renderEllipsis = (record) => {
    return (
      <div
        className={classes.actionsDiv}
        onClick={() => {
          setState({ selectedRowData: record });
          setSelectedRowKeys([record.reference_number]);
        }}
      >
        <EllipsisIcon />
      </div>
    );
  };

  const renderActions = (record) => {
    return (
      <Dropdown
        overlay={() => actionMenu(record, false)}
        trigger={['click']}
        onVisibleChange={(visible) => {
          if (!visible) {
            if (
              isDeliveryPickupModalVisible ||
              isReasonModalVisible ||
              isEditPieceDetailsModalVisible
            ) {
              return;
            }
            setSelectedRowKeys([]);
            setState({ selectedRowData: {} });
          }
        }}
      >
        {renderEllipsis(record)}
      </Dropdown>
    );
  };

  const renderPartialDelivery = (data) => {
    if (!data || data === 'No') return <></>;
    return (
      <span>
        {t('Yes')}
        <WarningFilled
          style={{ fontSize: 18, color: '#EC544A', marginLeft: 8 }}
        />
      </span>
    );
  };

  const generateColumnsToShow = () => {
    const columnData: {
      title: string;
      dataIndex: string;
      key: string;
      width: number;
      fixed?: any;
      render?: (data: any, record: any) => React.ReactElement;
    }[] = [];

    let fullColumnList = [];
    if (tripType === 'ist') {
      fullColumnList = DeliveryConsignmentISTColumnList;
    } else {
      fullColumnList = DeliveryConsignmentTripColumnList;
    }
    fullColumnList?.forEach((item) => {
      const { column_id } = item;
      const itemToPush = {
        title: t(item.pretty_name),
        dataIndex: column_id,
        key: column_id,
        width: item.width || 150,
      };

      switch (column_id) {
        case 'customer_pod':
        case 'vendor_image_url_list':
          itemToPush['render'] = (_, record) => renderGallery(record[column_id]);
          break;
        case 'status':
          itemToPush['render'] = (_, record) => t(getConsignmentStatusPrettyName(record[column_id]));
          break;
        case 'is_partial_pickedup':
        case 'is_partial_delivery':
          itemToPush['render'] = (_, record) => renderPartialDelivery(record[column_id]);
          break;
        default:
          itemToPush['render'] = (_, record) => _;
          break;
      }

      columnData.push(itemToPush);
    });

      columnData.push({
        title: t('Actions'),
        dataIndex: 'actions',
        key: 'actions',
        width: 100,
        fixed: 'right',
        render: (_, record) => renderActions(record),
      });

    return columnData;
  };

  const rowSelection = {
    selectedRowKeys: deliveryAcknowledgement.selectedRowKeys,
    onChange: (selectedRowKeys: string[]) => {
      setSelectedRowKeys(selectedRowKeys);
    },
    getCheckboxProps: (record) => ({
      disabled: ['delivered', 'attempted'].includes(record.status),
    }),
  };

  const handleCNSearch = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const query = e.target.value;
    filterCnData(query);
  };

  const handlePODUpload = (filesToUpload) => {
    uploadFilesAndSave(filesToUpload);
  };

  useEffect(() => {
    if (!deliveryAcknowledgement.uploadLoading) {
      setState({ isUploadPODModalVisible: false });
    }
  }, [deliveryAcknowledgement.uploadLoading]);

  const renderPODUploadModal = () => {
    return (
      <PodUpload
        isVisible={isUploadPODModalVisible}
        loading={deliveryAcknowledgement.uploadLoading}
        handleSubmit={handlePODUpload}
        title={t("Upload Vendor POD")}
        onModalClose={(e) => setState({ isUploadPODModalVisible: false })}
      />
    );
  };

  const deleteVendorPOD = (indexOfPODToRemove) => {
    const podlist = [...deliveryAcknowledgement.podList];
    podlist.splice(indexOfPODToRemove, 1);
    updateInvoicePODList(podlist);
  };

  const checkIfAllCNsAreComplete = () => {
    const { consignments } = deliveryAcknowledgement;
    const totalCNs = consignments?.length ?? 0;
    const completeCNs = consignments?.filter(
      (cn) => ['delivered', 'attempted'].includes(cn.status),
    )?.length ?? 0;

    return totalCNs === completeCNs;
  };

  const renderVendorPOD = (): React.ReactElement => {
    return (
      <>
        {deliveryAcknowledgement.consignments.length ? (
          <>
            {deliveryAcknowledgement?.podList && deliveryAcknowledgement?.podList?.length ? (
              <>
                {deliveryAcknowledgement.podList.map((elem, index) => (
                  <div style={{ marginTop: 0 }} key={elem.url}>
                    <span
                      style={{ cursor: 'pointer', marginRight: '8px' }}
                      onClick={
                        (e) => {
                          switch (elem.type) {
                            case 'pdf':
                              setState({
                                isPdfViewVisible: true,
                                pdfUrl: elem.url,
                              });
                              break;
                            default:
                              setState({
                                isImageModalVisible: true,
                                galleryImageData: [elem.url],
                              });
                              break;
                          }
                        }
                      }
                    >
                      <b>{t('View')}</b>
                    </span>
                    {
                      !checkIfAllCNsAreComplete() &&
                      <DeleteOutlined onClick={(e) => deleteVendorPOD(index)} />
                    }
                  </div>
                ))}
              </>
            ) : (
              <span>
                <b>{t('Not Available')}</b>
              </span>
            )}
            <Button
              type="link"
              style={{
                cursor: 'pointer',
                color: checkIfAllCNsAreComplete() ? '#393939' : '#065492',
              }}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setState({ isUploadPODModalVisible: true });
              }}
              disabled={checkIfAllCNsAreComplete()}
              icon={<CloudUploadOutlined />}
            >
              {t('Upload POD')}
            </Button>
          </>
        ) : (
          <span>
            <b>-</b>
          </span>
        )}
      </>
    );
  };

  const renderViewTable = () => (
    <div className={classes.tableContainer}>
      <div className={classes.buttonContainer}>
        <div style={{ paddingRight: 16 }}>
          {showBulkUpload &&
            <Dropdown overlay={() => actionMenu({}, true)} trigger={['click']}>
              <Button type="primary">
                {t('Actions')} <DownOutlined />
              </Button>
            </Dropdown>}
        </div>
        <Input.Search style={{ width: '250px' }} placeholder={t("Reference Number")} onChange={handleCNSearch} />
      </div>
      <Table
        rowKey={(record) => record['reference_number']}
        className={classes.table}
        dataSource={deliveryAcknowledgement.filteredConsignments || []}
        columns={generateColumnsToShow()}
        rowSelection={showBulkUpload ? rowSelection : undefined}
        loading={deliveryAcknowledgement.loader}
        scroll={{ x: 1200 }}
      />
    </div>
  );

  const searchInvoiceNumbers = (query: string) => {
    if (!query) {
      message.error(t('Please Enter Number'));
      return;
    }
    if (tripType === 'ist') {
      fetchISTInvoiceNumbers({ type: searchType, query });
    } else {
      fetchInvoiceNumbers({ type: searchType, query });
    }
  };

  const renderSearchInvoiceNumber = (): React.ReactElement => {
    const { dropdownNumberList } = deliveryAcknowledgement;
    const uniqueDropdownNumberList = lodash.uniq(dropdownNumberList) ?? [];
    const invoiceOptions = uniqueDropdownNumberList?.map((elem) => ({
      key: elem,
      label: elem.toUpperCase(),
      })) ?? [];
    return (
      <span className={classes.searchContainer}>
        {showVehicleRequestsMM &&
          <span style={{ marginRight: '16px' }}>
            <Select
              value={tripType}
              onChange={handleTripTypeChange}
              className={classes.searchTypeDropdown}
              options={tripTypes}
            />
          </span>}
        <span style={{ marginRight: '16px' }}>
          <Select
            value={searchType}
            onChange={handleSearchTypeChange}
            className={classes.searchTypeDropdown}
            options={tripType === 'ist' ? istSearchTypes : searchTypes}
          />
        </span>

        <SearchSelectTagsInput
          placeholder={t("Search Number")}
          className={classes.searchStyle}
          options={invoiceOptions}
          searchFunction={searchInvoiceNumbers}
          loading={deliveryAcknowledgement.searchLoading}
          onChange={(value) => {
            if (value) {
              getInvoiceConsignments({ type: searchType, number: value.value });
            }
          }}
          suffixIcon={<SearchOutlined />}
        />
      </span>
    );
  };

  const renderPdfViewer = () => {
    return (
      <Modal
        width={600}
        title={t("Vendor POD")}
        visible={isPdfViewVisible}
        onCancel={() => setState({ isPdfViewVisible: false, pdfUrl: null })}
        footer={null}
      >
        <PdfRenderer
          url={pdfUrl}
          loading={false}
          height={400}
        />
      </Modal>
    );
  };

  const renderEditPieceDetailsModal = () => {
    if (!isEditPieceDetailsModalVisible) return null;

    return (
      <EditPieceDetailsSideDrawer
        isVisible={isEditPieceDetailsModalVisible}
        handleClose={() => {
          setState({
            isEditPieceDetailsModalVisible: false,
            selectedRowData: {},
            actionType: null,
          });
          setPieceLevelActions({});
          setEventTimestamp({ date: null, time: null });
        }}
        consignmentData={selectedRowData}
        actionType={actionType}
      />
    );
  };

  return (
    <div className={classes.mainDiv}>
      <Navbar title={t("Consignments")} />
      <div className={classes.bodyDiv}>
        {renderSearchInvoiceNumber()}
        {renderViewTable()}
        {isReasonModalVisible && (
          <NdrNprReasonModal
            isVisible={isReasonModalVisible}
            actionType={reasonModalAction as any}
            onCancel={closeReasonModal}
            onConfirm={handleReasonConfirm}
            selectedRows={deliveryAcknowledgement.selectedRowKeys}
          />
        )}
        {isImageModalVisible && (
          <Modal
            width={400}
            title={t("Vendor POD")}
            visible={isImageModalVisible}
            onCancel={() => setState({ isImageModalVisible: false })}
            footer={null}
          >
            <div className={classes.carouselWrapper}>
              <Carousel
                prevArrow={<LeftCircleOutlined />}
                nextArrow={<RightCircleOutlined />}
                arrows
              >
                {galleryImageData?.map((data: any) => (
                  <div key={data}>
                    <RenderImage image={{ url: data }} />
                  </div>
                ))}
              </Carousel>
            </div>
          </Modal>
        )}
        {isUploadPODModalVisible && renderPODUploadModal()}
        {isPdfViewVisible && renderPdfViewer()}
        {renderEditPieceDetailsModal()}
        {isDeliveryPickupModalVisible && (
          <DeliveryPickupModal
            isVisible={isDeliveryPickupModalVisible}
            actionType={deliveryPickupAction as any}
            onCancel={() => setIsDeliveryPickupModalVisible(false)}
            onConfirm={({ podUrlList, eventTime }) => handleDeliveryPickupConfirm({
              podUrlList,
              eventTime,
              actionType: deliveryPickupAction,
            })}
            selectedRows={deliveryAcknowledgement.selectedRowKeys}
            consignments={deliveryAcknowledgement.consignments}
          />
        )}
      </div>
    </div>
  );
};

const mapStateToProps = ({ masterData, deliveryAcknowledgement, ticketingTool }) => {
  const { vendor_config } = masterData;
  return {
    deliveryAcknowledgement,
    orgData: ticketingTool.orgData,
    showPieceLevelActions: vendor_config?.consignment_action_config?.show_piece_level_actions,
    showVehicleRequestsMM: vendor_config?.show_vehicle_requests_mm || false,
    ticketingToolURL: ticketingTool.ticketingToolURL,
    consignmentActionConfig: vendor_config?.consignment_action_config || {},
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getInvoiceConsignments: (data) => dispatch(getInvoiceConsignmentList(data)),
    updateInvoicePODList: (data) => dispatch(updateInvoicePodList(data)),
    uploadFilesAndSave: (data) => dispatch(uploadFilesAndSavePOD(data)),
    fetchInvoiceNumbers: (data) => dispatch(fetchInvoiceNumbers(data)),
    fetchISTInvoiceNumbers: (data) => dispatch(fetchISTInvoiceNumbers(data)),
    setSelectedRowKeys: (data) => dispatch(setSelectedRowKeys(data)),
    markCNsAsDelivered: (data) => dispatch(markCNsAsDelivered(data)),
    markCNsAsDeliveredIST: () => dispatch(markCNsAsDeliveredIST()),
    markCNsAsPickedUp: (data) => dispatch(markCNsAsPickedUp(data)),
    markCNsAsNotPickedUp: (data) => dispatch(markCNsAsNotPickedUp(data)),
    markCNsAsUndelivered: (data) => dispatch(markCNsAsUndelivered(data)),
    markCNsAsUndeliveredIST: () => dispatch(markCNsAsUndeliveredIST()),
    filterCnData: (data) => dispatch(filterCnData(data)),
    setPieceLevelActions: (data) => dispatch(setPieceLevelActions(data)),
    setEventTimestamp: (data) => dispatch(setEventTimestamp(data)),
    setTicketingToolVisibility: (data) => dispatch(setTicketingToolVisibility(data)),
    setTicketingToolURL: (data) => dispatch(setTicketingToolURL(data)),
  };
};

const hocConfig: HocOptions = {
  connectRedux: {
    useRedux: true,
    mapStateToProps,
    mapDispatchToProps,
  },
  connectJss: {
    useJss: true,
    styleSheet: DeliveryRequestStyles,
  },
  connectRouter: true,
  connectTranslession: true,
};

export default GenericHoc(hocConfig)(DeliveryAcknowledgement);
